import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ResourceDocumentation } from '@mtna/pojo-consumer-ts';
import { RdsDataProduct } from '@rds/rds-metadata-ts';

import { CanLoadCtor, mixinLoading } from '../core/common-behaviors';

// Boilerplate for applying mixins to RdsResourceDocumentationComponent.
class RdsResourceDocumentationBase {}
const _RdsResourceDocumentationMixinBase: CanLoadCtor = mixinLoading(RdsResourceDocumentationBase);

/**
 * Resource documentation component to display the documents that are attatched to a documented resource.
 * This should take a resource that has a 'documents' property set on it which are an array of ResourceDocumentation objects.
 *
 * @author Andrew DeCarlo <andrew.decarlo@mtna.us>
 */
@Component({
  selector: 'rds-c-resource-documentation',
  templateUrl: './resource-documentation.component.html',
  styleUrls: ['./resource-documentation.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RdsResourceDocumentationComponent extends _RdsResourceDocumentationMixinBase {
  /** The resource that has the documentation set on it. Currently this is hardcoded to an RdsDataProduct but should be refactored to be a DocumentedResource if that model becomes available.  */
  @Input() documentedResource: RdsDataProduct | null | undefined;

  /** The header that will be displayed above the table of documents */
  @Input() header = $localize`Supplemental Documents`;

  /** The columns to display in the table */
  displayedColumns = ['document', 'description', 'action'];

  /** URI of the row(document) currently selected */
  selectedRow: string | null | undefined;

  /** The selected document */
  @Output() selected = new EventEmitter<ResourceDocumentation>();

  /**
   * Sets the URI of the selected row and emits the ResourceDocumentation that was selected.
   *
   * @param row the row that was selected
   */
  handleSelectRow(row: ResourceDocumentation) {
    this.selectedRow = row.uri;
    this.selected.emit(row);
  }
}
